export default __webpack_public_path__ + "images/onboarding/tick-2-ffa566becb722270e3931e8b163a7ead.svg";